namespace services {
    $(document).ready(() => {
        var clickableRow = "tr.clickable, li.clickable, div.clickable";
        $(clickableRow).on("click", "em.fa", (event: any) => {
            event.stopPropagation();
        });

        $(clickableRow).click(function () {
            var link = $(this).data('href');
            window.location.href = link;
        });
    });
}